// Auto-generated by the generator
// Don't manually edit this file

// @flow

import {setReady} from './setReady'
import {setApiIndex} from './setApiIndex'
import {setServiceProviders} from './setServiceProviders'
import {setGoogleMap} from './setGoogleMap'
import {setLocation} from './setLocation'
import {onPlaceSearch} from './onPlaceSearch'
import {onClickPlace} from './onClickPlace'
import {setCities} from './setCities'
import {setDistricts} from './setDistricts'
import {setSelectedCity} from './setSelectedCity'
import {searchByText} from './searchByText'
import {searchByLocation} from './searchByLocation'

export const mapActions = {
  setReady,
  setApiIndex,
  setServiceProviders,
  setGoogleMap,
  setLocation,
  onPlaceSearch,
  onClickPlace,
  setCities,
  setDistricts,
  setSelectedCity,
  searchByText,
  searchByLocation,
}
